import CreateMisconceptionView from "@features/tools/view/misconceptions-view/create-misconception-view";

const CreateMisconceptions = () => {
  return <CreateMisconceptionView />;
};

export default CreateMisconceptions;
